module.exports = __webpack_public_path__ + "img/s1.6ee69888.png";